var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReorganisationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8622",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8622",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAC9klEQVR4nO3cv04UURzF8TMboYEXQKG0FmOivoTBRB/BGIyWFhprtbBCK1pjLyH6CP6JipXxb8sTCIWJCV+LGc3mAht3Z+bOb3fOp1sC956Zk2F35sKVzMzMzMzMzMzMzMxaA8wDt4C3wD717QNvgJvAfNfHN1WAk8DHBko4zg6w1PVxTgXKK6PNMv76AMx1fbypQdcBjnBd0tkM85yTdC3DPNON8j1j2AvgVAPjLgMvk7FfN5F5pgF7yUlbbnDslWTsn02N3ZSi6wApgOHXRVE0mrHt8euK+B7Say4kGBcSjAsJxoUE40KCcSHBuJBgXEgwEQvZG37R9KOTUXNFELGQz8nrzSZKqcrYTL78qe64M49yRS+X9a6PNzzKBaqdDGW8I+ACVUjAEuWKXlve4yXc8QBzwA3gFYfXSCaxV421TuArI9RawCQg9vrGuCJ+yuo1FxKMCwnGhQTjQoJxIcG4kGAa+cxe3WitSbqs8k80VyQtNDF2YPuSdiXtSHouabsoit91B61dCLAm6ZGk03XHmnI/JN0uimK7ziAT/8oCBsBDSVtyGVJ5DraAB8DE5/VEjQD3Jd2p8fOzqJB0VxKS7mWbFVgDDpKHd7+ADeACkO39I32CmHHehepYH1fHPuwAuJQryBzwPQmwC5zJEuBwnk4KSTKsVudg2LcsT5WBq0dcGZ2UUeXpvJAqx+oRV8qVHBM/SybdaH3S0XlCFFJleZLEeZpj0q/JpOdbn3R0nkiFXEzifMkxabp6t9j6pKPzRCpkMYkz9n9ojX1jmB501yt0s5bHz7KCcSHBuJBgXEgwLiQYFxKMCwnGhQTjQoL5Vwj/uYNbOsBx30fNHdx6nYdgO7j1Og/BdnDre56B4u3g1u88BNvBrfd5CLaDW9/zFBBrB7e+5/F9SDAuJBgXEowLCcaFBONCgnEhwbiQYFxIMAPF28Gt13kGireDW7/zEGwHt97nIdgObs6jeDu4OY/i7eDmPGZmZmZmZmZmZmY2vf4Ar+NZ2EIp+fcAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorganisationIcon);
export default __webpack_public_path__ + "static/media/ReorganisationIcon.4c763605466c080b566396abee9cf42e.svg";
export { ForwardRef as ReactComponent };